var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0376 14.7695C20.2417 14.7695 14.7314 20.2797 14.7314 27.0757C14.7314 33.8716 20.2417 39.3818 27.0376 39.3818C33.8335 39.3818 39.3437 33.8716 39.3437 27.0757C39.307 20.2797 33.7968 14.7695 27.0376 14.7695V14.7695Z",
    fill: "url(#paint0_linear_567_1486)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6692 15.8658C47.7733 15.8658 50.2896 13.3495 50.2896 10.2454C50.2896 7.14134 47.7733 4.625 44.6692 4.625C41.5652 4.625 39.0488 7.14134 39.0488 10.2454C39.0488 13.3495 41.5652 15.8658 44.6692 15.8658Z",
    fill: "url(#paint1_linear_567_1486)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5755 15.8694L51.3551 15.3551L50.9878 15.7959C50.0694 16.8245 48.8939 17.6327 47.6082 18.1102L47.2408 18.2571L47.3878 18.6245C48.5265 21.3061 49.0776 24.1714 49.0776 27.0735C49.0776 39.2327 39.1959 49.151 27 49.151C14.8041 49.151 4.95918 39.2327 4.95918 27.0735C4.95918 14.9143 14.8408 4.99592 27.0367 4.99592C30.3429 4.99592 33.502 5.73061 36.4776 7.12653L36.8082 7.27347L36.9551 6.90612C37.5061 5.62041 38.351 4.51837 39.4531 3.63673L39.8939 3.26939L39.3796 3.01224C35.5225 1.02857 31.3714 0 27 0C12.1225 0 0 12.1225 0 27C0 41.8776 12.1225 54 27 54C41.8776 54 54 41.8776 54 27C54 23.1796 53.1918 19.4327 51.5755 15.8694V15.8694Z",
    fill: "url(#paint2_linear_567_1486)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_1486",
    x1: 27.0376,
    y1: 14.7695,
    x2: 27.0376,
    y2: 39.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D34E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_1486",
    x1: 44.6692,
    y1: 4.625,
    x2: 44.6692,
    y2: 15.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D34E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_1486",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D34E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932A9A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.9c92839d82647b78f8fb110066c076c6.svg";
export { ForwardRef as ReactComponent };